export enum CreatorEvents {
    TRACKS_UPDATED = 'TRACKS_UPDATED',
    TRACK_GAIN_UPDATED = 'TRACK_GAIN_UPDATED',
    PLAYBACK_UPDATED = 'PLAYBACK_UPDATED',
    PAUSE_UPDATED = 'PAUSE_UPDATED',
    PROCESSING_UPDATED = 'PROCESSING_UPDATED',
    TRACK_STARTED = 'TRACK_STARTED',
}
